<template>
  <div
    @mouseenter="delayedMouseOpen(true)"
    @mouseleave="delayedMouseOpen(false)"
    v-on-clickaway="close"
    class="NavGuestFavouriteDropdown relative h-full hidden md:flex items-center justify-center"
  >
    <button class="NavGuestFavouriteDropdown__button relative" :class="$mq" @click="toggle">
      <img src="@/assets/icons/heart.svg" class="w-full md:w-[22px]" alt="Favourites" />

      <span class="NavGuestFavouriteDropdown__badge" v-if="favourites.length > 0">
        {{ favourites.length }}
      </span>
    </button>

    <div v-show="open" :class="$mq" class="NavGuestFavouriteDropdown__drop absolute text-black bg-white border">
      <slot :toggle="toggle"></slot>
    </div>
  </div>
</template>

<script>
import { sizeXS } from "@/lib/screenSizes"

const CART_POPUP_STEP = [1, 3, 6, 9]

export default {
  name: "Nav.Guest.FavouriteDropdown",
  props: {
    favourites: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      open: false,
      scrollListener: null,
    }
  },
  methods: {
    toggle() {
      this.open = !this.open
    },
    mouseOpen(state) {
      const media = matchMedia(`(max-width: ${sizeXS}px)`)
      if (media.matches) return

      this.open = state
    },
    delayedMouseOpen(state) {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => this.mouseOpen(state), 500)
    },
    close() {
      // Because clicking on anything will close,
      // thus even favouriting will immediately close after open
      // Check if clickaway is not a button
      const { nodeName: node } = event.target
      const blacklistNodes = ["path", "button", "svg"]

      if (this.open && !blacklistNodes.includes(node)) this.open = false
    },
  },
  watch: {
    favourites: {
      deep: true,
      handler: function (favs, favsOld) {
        const addFavourites = favs.length > favsOld.length
        const showCondition = CART_POPUP_STEP.includes(favs.length)

        if (addFavourites && showCondition) this.open = true
      },
    },
  },
}
</script>

<style lang="scss">
.NavGuestFavouriteDropdown__button {
  @apply text-black;
  font-size: 22px;

  &.xs {
    font-size: 28px;
  }
}

.NavGuestFavouriteDropdown__badge {
  @apply absolute bg-grey-darker text-white rounded-full flex justify-center text-xs;
  font-size: 13px;
  line-height: 1.6;
  width: 20px;
  height: 20px;
  top: -7px;
  right: -7px;
}

.NavGuestFavouriteDropdown__drop {
  z-index: 100;
  top: 58px;
  right: -20px;
  width: 390px;
  min-height: 100px;
  max-width: 85vw;

  &.xs {
    right: -30px;
  }
}
</style>
